import { CloseButton } from '@/widgets/components/close-button';
import React from 'react';
import {
  formatDatesForPDFSelection,
  formatListingsForPDFSelection,
  getListingInfo,
} from './pdf-viewer-utils';
import * as viewer from './property-details-pdf-view-styles';

/**
 * The pickers display the current Listing / Date context for the viewed pdf
 * These pickers also allow the user to change Listing / Scrape Date views
 *
 * @param {*} props
 * @returns The Two Cascade Listing/Date Pickers
 */
function StyledPickers(props) {
  const { listingData, dateData, initialListing, currentListing } = props;
  const LATEST_DATE_IDX = 0;
  const latestDate = `${dateData[LATEST_DATE_IDX].children[LATEST_DATE_IDX].children[LATEST_DATE_IDX].value}`;

  return (
    <viewer.FlexRowCenter>
      <viewer.StyledCascader
        defaultValue={initialListing}
        onChange={(value) => props.onListingSelect(value.split('-'))}
        data={listingData}
        cleanable={false}
        width={250}
      />
      <viewer.StyledCascader
        key={latestDate}
        defaultValue={latestDate}
        data={dateData}
        cleanable={false}
        onSelect={(value) => props.onDateSelect(currentListing, value)}
        width={150}
      />
    </viewer.FlexRowCenter>
  );
}

/**
 * Header portion of Modal. Here the logic for the Cascader Pickers is called
 * Two functions are at play: 1) formatListingForPDF 2) formatDatesForPDF
 *
 * The initial values for the Cascader Inputs also flow through here
 *
 * @param {*} props
 * @returns Header portion of Modal
 */
function PDFModalHeader(props) {
  const { listings, currentListingId, currentPlatform } = props;
  const currentListing = getListingInfo(
    listings,
    currentPlatform,
    currentListingId
  );
  const dateData = formatDatesForPDFSelection(currentListing);
  const initialListingValue = `${currentPlatform}-${currentListingId}`;

  return (
    <viewer.HeaderWrapper>
      <viewer.ListingHistory />
      <StyledPickers
        onListingSelect={props.onListingSelect}
        onDateSelect={props.onDateSelect}
        currentListing={currentListing}
        initialListing={initialListingValue}
        dateData={dateData}
        listingData={formatListingsForPDFSelection(listings)}
      />
      <CloseButton onClick={props.closePdfModal} />
    </viewer.HeaderWrapper>
  );
}

export default PDFModalHeader;
